import { css } from "@emotion/react"
import { Amount } from "../types"
import { formattedCents } from "../utils/designationTotal"

export function PaneWrapper({ children }: { children: React.ReactNode }) {
  return <div className="d-f jc-sb my-3">{children}</div>
}

export function ContinueAuthedDisplay({
  totalCents,
  onClick,
}: {
  totalCents: number
  onClick: () => void
}) {
  return (
    <button className="btn" onClick={onClick}>
      Continue to give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
    </button>
  )
}

export function FormSubmitDisplay({
  handleSubmit,
  totalCents,
}: {
  handleSubmit: () => void
  totalCents: number
}) {
  return (
    <button className="btn" onClick={handleSubmit}>
      Give{totalCents > 0 && ` ${formattedCents(totalCents)}`}
    </button>
  )
}

export function AmountInputDisplay({
  amount,
  onChange,
  readOnly = false,
  onBlur,
}: {
  amount: Amount
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  readOnly?: boolean
  onBlur?: () => void
}) {
  const CURRENCY_SYMBOL = "$"

  return (
    <div className="d-f jc-c">
      <span className="fs-0 c-tint3 pt-1">{CURRENCY_SYMBOL}</span>
      <input
        type="text"
        inputMode="decimal"
        placeholder="0"
        value={amount}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
        css={css`
          // add specificity to override doxy defaults
          &[type="text"] {
            border: none;
            height: auto;
            line-height: 1;
            font-size: 72px;
            padding-inline: 0.25rem;
            padding-block: 0;
            border-bottom: 3px solid transparent;
            border-radius: 0 !important;
            min-width: calc(1ch + 0.5rem);
            max-width: 100%;

            &[readonly] {
              background-color: transparent;
              cursor: not-allowed;
            }

            &:active,
            &:focus {
              border-color: var(--color-tint3);
              background-color: transparent;
              outline: none;
              box-shadow: none;
            }
          }
        `}
        style={{
          width: `calc(${amount.length}ch + 0.5rem)`,
        }}
      />
    </div>
  )
}
